module.exports = __webpack_public_path__ + "static/media/application-on-devices.74daaa39.png";